import { Routes, Route } from 'react-router-dom';
import HeadPages from './HeadPages';
import DACalendar from './DACalendar';

const App = () => {
  const hostname = window.location.hostname;

  return (
    <Routes>
      <Route path="/" element={<HeadPages />} />
      {hostname === "emilymabey.com" && (
        <Route path="/dacal" element={<DACalendar />} />
      )}
      {/* <Route path="/dacal" element={<DACalendar />} /> */}
    </Routes>
  );
};

export default App;